import { useEffect, useState } from 'react';

import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';

import { Propertybookings } from '../../Services/Service';

export const AgentBookingReport = () => {

    const [bookingData, setBookingData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchBookings = async (params = {}) => {
        setLoading(true);
        try {
            const data = await Propertybookings(params);
            // setBookingData(data || []);
            setBookingData((data || []).reverse());
        } catch (error) {
            console.log("Error fetching bookings", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchBookings();
    }, [])


    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />

                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">

                                    <form className='row'>
                                        <div className='col-md-3 mb-3'>
                                            <label className='form-label'>Agent Name</label>
                                            <input className='form-control' type='text' placeholder='Enter Name'/>
                                        </div>
                                        <div className='col-md-2'>
                                            <label className='form-label'>Boooking Date</label>
                                            <input className='form-control' type='date'/>
                                        </div>
                                        <div className='col-md-2'>
                                            <label className='form-label'>Check IN</label>
                                            <input className='form-control' type='date'/>
                                        </div>
                                        <div className='col-md-2'>
                                            <label className='form-label'>Check Out</label>
                                            <input className='form-control' type='date'/>
                                        </div>

                                        <div className='col-md-1'>
                                            <button
                                                className='btn btn-primary me-2'
                                                type='button'
                                                style={{marginTop:"28px"}}
                                            >
                                                Filter
                                            </button>
                                        </div>

                                    </form>

                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">Agent Booking Report</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table
                                                    className="display table  table-bordered table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "45px" }}>Sr#</th>
                                                            <th style={{ width: "110px" }} >BON REF. Id</th>
                                                            <th style={{ width: "110px" }}>Conf. No</th>
                                                            <th style={{ width: "95px" }}>Check-in</th>
                                                            <th style={{ width: "110px" }}>Check-out</th>
                                                            <th >Guest Info</th>
                                                            <th style={{ width: "81px" }}>Payment </th>
                                                            <th style={{ width: "81px" }}>Status</th>
                                                            <th style={{ width: "95px" }}>Book On</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {bookingData.map((item) => (
                                                            <tr key={item.ID}>
                                                                <td>{item.SrNo}</td>
                                                                <td>{item.BONRESID}</td>
                                                                <td>{item.PMSRESID}</td>
                                                                <td>{item.CheckInDate}</td>
                                                                <td> {item.CheckOutDate}</td>
                                                                <td>
                                                                    <b>{item.GuestName}</b>
                                                                    <div>{item.CompanyName}</div>
                                                                </td>
                                                                <td>
                                                                    <div> <span > ₹ {item.TotalPayment} </span></div>
                                                                    <div>
                                                                        <span
                                                                            className={
                                                                                item.PaymentStatus === "Paid"
                                                                                    ? "text-success"
                                                                                    : item.PaymentStatus === "Pending"
                                                                                        ? "text-warning"
                                                                                        : "text-secondary"
                                                                            }
                                                                        >
                                                                            {item.PaymentStatus || "N/A"}
                                                                        </span>
                                                                    </div>
                                                                </td>

                                                                <td className="text-center">
                                                                    <span
                                                                        className={
                                                                            item.BookingStatus === "Confirmed"
                                                                                ? "text-success"
                                                                                : item.BookingStatus === "Pending"
                                                                                    ? "text-warning"
                                                                                    : item.BookingStatus === "Cancelled"
                                                                                        ? "text-danger"
                                                                                        : "text-secondary"
                                                                        }
                                                                    >
                                                                        {item.BookingStatus || "N/A"}
                                                                    </span>
                                                                </td>
                                                                <td>{item.BookingDate}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    );
};
